export default {
    poppins : 'Poppins, Helvetica, Arial, sans-serif',
}